import { render } from "./RechargePackages.vue?vue&type=template&id=494f5c2e&scoped=true"
import script from "./RechargePackages.vue?vue&type=script&lang=js"
export * from "./RechargePackages.vue?vue&type=script&lang=js"

import "./RechargePackages.vue?vue&type=style&index=0&id=494f5c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494f5c2e"]])

export default __exports__